import { render } from "./ResourceCountUsage.vue?vue&type=template&id=3d074a7f&scoped=true"
import script from "./ResourceCountUsage.vue?vue&type=script&lang=js"
export * from "./ResourceCountUsage.vue?vue&type=script&lang=js"

import "./ResourceCountUsage.vue?vue&type=style&index=0&id=3d074a7f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d074a7f"]])

export default __exports__